import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { FormViewer } from '@juvare/common-form-ui/FormViewer';
import { Divider } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BackgroundCheckTypeSelectProps {
    backgroundCheckType: string | undefined;
    setSelectedBackgroundCheckType: (type: BackgroundCheckType) => void;
}

const getBackgroundCheckTypeFormConfig = (t: TFunction<'rms'>) => ({
    type: 'form',
    children: [
        {
            type: 'form.advancedRadio',
            key: 'type',
            label: t('backgroundCheck.labels.backgroundCheckType'),
            validate: {
                required: true,
            },
            valueProvider: {
                type: 'backgroundCheckEnabledTypes',
            },
        },
    ],
});

export const BackgroundCheckTypeSelect: React.FC<BackgroundCheckTypeSelectProps> = ({
    backgroundCheckType,
    setSelectedBackgroundCheckType,
}) => {
    const { t } = useTranslation('rms');

    return (
        <>
            <Divider sx={{ mb: 2 }} />

            <FormViewer
                config={getBackgroundCheckTypeFormConfig(t)}
                data={{
                    type: backgroundCheckType,
                }}
                onDataChange={(newData) => {
                    setSelectedBackgroundCheckType(newData.data.type);
                }}
            />
        </>
    );
};
